export const contacts: any = [
	{
		id: 1,
		profile_picture: '/static/media/profile-picture-girl-3.6f306e62.jpeg',
		name: 'Pulseem',
		phone_number: '+2348123456789',
		whatsapp_name: 'Beyonce',
		unread: 3,
		messages: {
			'04/06/2021': [
				{
					content:
						'She insisted that cleaning out your closet was the key to good driving.',
					sender: 1,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						'Mary realized if her calculator had a history, it would be more embarrassing than her computer browser history.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"Gary didn't understand why Doug went upstairs to get one dollar bills when he invited him to go cow tipping.",
					sender: 1,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'The bees decided to have a mutiny against their queen.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			YESTERDAY: [
				{
					content:
						"Henry couldn't decide if he was an auto mechanic or a priest.",
					sender: 1,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'I hear that Nancy is very pretty. ',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'Cats are good pets, for they are clean and are not noisy.',
					sender: 1,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'They improved dramatically once the lead singer left. ',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content:
						'The small white buoys marked the location of hundreds of crab pots.',
					sender: null,
					time: '08:10:26',
					status: null,
				},
				{
					content:
						"Shakespeare was a famous 17th-century diesel mechanic. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 1,
					time: '08:11:26',
					status: null,
				},
				{
					image: true,
					sender: 1,
					time: '09:12:26',
					status: null,
				},
				{
					content:
						'The small white buoys marked the location of hundreds of crab pots.',
					sender: null,
					time: '08:12:45',
					status: 'read',
				},
				{
					image: true,
					sender: null,
					time: '09:13:26',
					status: null,
				},
				{
					content: "Please put on these earmuffs because I can't you hear.",
					sender: 1,
					time: '09:20:26',
					status: null,
				},
				{
					content:
						"Henry couldn't decide if he was an auto mechanic or a priest.",
					sender: 1,
					time: '09:21:26',
					status: null,
				},
			],
		},
		group: false,
		pinned: true,
		typing: false,
	},
	{
		id: 2,
		profile_picture: '/static/media/profile-picture-girl-2.0ab9429c.jpeg',
		name: 'Karen Okonkwo',
		phone_number: '+2348123456789',
		whatsapp_name: 'Karen O.',
		unread: 0,
		messages: {
			'04/06/2021': [
				{
					content:
						'The green tea and avocado smoothie turned out exactly as would be expected.',
					sender: 2,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'Ooooh. That seems interesting. Tell me more!',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'The Japanese yen for commerce is still well-known.',
					sender: 2,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'We can make the bird fly away if we jump on something.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			YESTERDAY: [
				{
					content: 'The bees decided to have a mutiny against their queen.',
					sender: 2,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						"We are going to swim at the park. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'My big yellow cat ate the little black bird.',
					sender: 2,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						"It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.\tIt's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content:
						'Mary realized if her calculator had a history, it would be more embarrassing than her computer browser history.',
					sender: 2,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						'When he asked her favorite number, she answered without hesitation that it was diamonds.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						'The green tea and avocado smoothie turned out exactly as would be expected.',
					sender: 2,
					time: '09:11:26',
					status: null,
				},
			],
		},
		group: false,
		pinned: false,
		typing: false,
	},
	{
		id: 3,
		profile_picture: '/static/media/profile-picture-girl-1.57190dd7.jpeg',
		name: 'Titilayo Bello',
		phone_number: '+2348123456789',
		whatsapp_name: 'titi123',
		unread: 0,
		messages: {
			'04/06/2021': [
				{
					content: 'Can we go to the park .',
					sender: 3,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						"Henry couldn't decide if he was an auto mechanic or a priest.",
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.\tIt's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 3,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						'Blue sounded too cold at the time and yet it seemed to work for gin.',
					sender: null,
					time: '09:15:45',
					status: 'sent',
				},
			],
			YESTERDAY: [
				{
					content:
						'The murder hornet was disappointed by the preconceived ideas people had of him.',
					sender: 3,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'Dan ate the clouds like cotton candy.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						'The small white buoys marked the location of hundreds of crab pots.',
					sender: 3,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'Sometimes you have to just give up and win by cheating.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content: 'The bees decided to have a mutiny against their queen.',
					sender: 3,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						'The clock within this blog and the clock on my laptop are 1 hour different from each other.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						'When he asked her favorite number, she answered without hesitation that it was diamonds.',
					sender: 3,
					time: '09:11:26',
					status: null,
				},
				{
					image: true,
					sender: 3,
					time: '09:12:26',
					status: null,
				},
				{
					image: true,
					sender: null,
					time: '09:13:26',
					status: null,
				},
				{
					content:
						"Henry couldn't decide if he was an auto mechanic or a priest.",
					sender: null,
					time: '09:15:45',
					status: 'sent',
				},
			],
		},
		group: false,
		pinned: false,
		typing: false,
	},
	{
		id: 4,
		profile_picture: '/static/media/profile-picture-boy-2.1f40d9c2.jpeg',
		name: 'David Schwimmer',
		phone_number: '+2348123456789',
		whatsapp_name: 'David',
		unread: 1,
		messages: {
			'04/06/2021': [
				{
					content: 'He strives to keep the best lawn in the neighborhood.',
					sender: 4,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'Joyce enjoyed eating pancakes with ketchup.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"It's much more difficult to play tennis with a bowling ball than it is to bowl with a tennis ball.",
					sender: 4,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						"We are going to swim at the park. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			YESTERDAY: [
				{
					content:
						"Shakespeare was a famous 17th-century diesel mechanic. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 4,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						'The murder hornet was disappointed by the preconceived ideas people had of him.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'They improved dramatically once the lead singer left. ',
					sender: 4,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'Ooooh. That seems interesting. Tell me more!',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content: 'In that instant, everything changed. ',
					sender: 4,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						'Blue sounded too cold at the time and yet it seemed to work for gin.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"We are going to swim at the park. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 4,
					time: '09:11:26',
					status: null,
				},
				{
					content: "Don't step on the broken glass.",
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
				{
					content:
						"All she wanted was the answer, but she had no idea how much she would hate it. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 4,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						'They ran around the corner to find that they had traveled back in time.',
					sender: 4,
					time: '09:11:26',
					status: null,
				},
			],
		},
		group: false,
		pinned: false,
		typing: false,
	},
	{
		id: 5,
		profile_picture: '/static/media/profile-picture-boy-1.81eb50a9.jpeg',
		name: 'Daniel Oladeji',
		phone_number: '+2348123456789',
		whatsapp_name: 'Beyonce',
		unread: 0,
		messages: {
			'04/06/2021': [
				{
					content:
						"Henry couldn't decide if he was an auto mechanic or a priest.",
					sender: 5,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'The Japanese yen for commerce is still well-known.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'I currently have 4 windows open up… and I don’t know why.',
					sender: 5,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						"That is an appealing treasure map that I can't read. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			YESTERDAY: [
				{
					content: "Please put on these earmuffs because I can't you hear.",
					sender: 5,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'I currently have 4 windows open up… and I don’t know why.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"He invested some skill points in Charisma and Strength. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 5,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'Carol drank the blood as if she were a vampire.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content:
						"His confidence would have bee admirable if it wasn't for his stupidity. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 5,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'My big yellow cat ate the little black bird.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'Her scream silenced the rowdy teenagers.',
					sender: 5,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						'The murder hornet was disappointed by the preconceived ideas people had of him.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
		},
		group: false,
		pinned: false,
		typing: false,
	},
	{
		id: 6,
		profile_picture: '/static/media/profile-picture-boy-3.025dcbc9.jpeg',
		name: 'Chris Breno',
		phone_number: '+2348123456789',
		whatsapp_name: 'Chris',
		unread: 3,
		messages: {
			'04/06/2021': [
				{
					content: 'Cats are good pets, for they are clean and are not noisy.',
					sender: 6,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						"Henry couldn't decide if he was an auto mechanic or a priest.",
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						'Blue sounded too cold at the time and yet it seemed to work for gin.',
					sender: 6,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'The bees decided to have a mutiny against their queen.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			YESTERDAY: [
				{
					content:
						'Blue sounded too cold at the time and yet it seemed to work for gin.',
					sender: 6,
					time: '08:11:26',
					status: null,
				},
				{
					content:
						"His confidence would have bee admirable if it wasn't for his stupidity. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'Can we go to the park .',
					sender: 6,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'He enjoys practicing his ballet in the bathroom.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content:
						'The murder hornet was disappointed by the preconceived ideas people had of him.',
					sender: 6,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'We can make the bird fly away if we jump on something.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.\tIt's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 6,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'He went on a whiskey diet and immediately lost three days.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
				{
					content:
						"Shakespeare was a famous 17th-century diesel mechanic. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 6,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'My big yellow cat ate the little black bird.',
					sender: 6,
					time: '09:11:26',
					status: null,
				},
			],
		},
		group: false,
		pinned: false,
		typing: false,
	},
	{
		id: 7,
		profile_picture: '/static/media/profile-picture-girl-3.6f306e62.jpeg',
		name: 'Karen Okonkwo',
		phone_number: '+2348123456789',
		whatsapp_name: 'Karen',
		unread: 0,
		messages: {
			'04/06/2021': [
				{
					content: 'Her scream silenced the rowdy teenagers.',
					sender: 8,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'In that instant, everything changed. ',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"At that moment he wasn't listening to music, he was living an experience.",
					sender: 7,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'He strives to keep the best lawn in the neighborhood.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			YESTERDAY: [
				{
					content: 'He decided to live his life by the big beats manifesto.',
					sender: 7,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'The Japanese yen for commerce is still well-known.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						'When he asked her favorite number, she answered without hesitation that it was diamonds.',
					sender: 7,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'The bees decided to have a mutiny against their queen.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content:
						'She insisted that cleaning out your closet was the key to good driving.',
					sender: 7,
					time: '08:11:26',
					status: null,
				},
				{
					content: "Don't step on the broken glass.",
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"All she wanted was the answer, but she had no idea how much she would hate it. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 7,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						"Gary didn't understand why Doug went upstairs to get one dollar bills when he invited him to go cow tipping.",
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
		},
		group: false,
		pinned: false,
		typing: false,
	},
	{
		id: 8,
		profile_picture: '/static/media/profile-picture-girl-4.64d88d46.jpeg',
		name: 'Beyoncé Knowles',
		phone_number: '+2348123456789',
		whatsapp_name: 'Beyonce',
		unread: 0,
		messages: {
			'04/06/2021': [
				{
					content:
						'The shark-infested South Pine channel was the only way in or out.',
					sender: 8,
					time: '08:11:26',
					status: null,
				},
				{
					content: 'He enjoys practicing his ballet in the bathroom.',
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content: 'In that instant, everything changed. ',
					sender: 8,
					time: '09:11:26',
					status: null,
				},
				{
					content: 'He strives to keep the best lawn in the neighborhood.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			YESTERDAY: [
				{
					content:
						"He invested some skill points in Charisma and Strength. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 8,
					time: '08:11:26',
					status: null,
				},
				{
					content: "Please put on these earmuffs because I can't you hear.",
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						"Shakespeare was a famous 17th-century diesel mechanic. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
					sender: 8,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						'The green tea and avocado smoothie turned out exactly as would be expected.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
			TODAY: [
				{
					content: 'Can we go to the park .',
					sender: 8,
					time: '08:11:26',
					status: null,
				},
				{
					content: "Please put on these earmuffs because I can't you hear.",
					sender: null,
					time: '08:15:45',
					status: 'read',
				},
				{
					content:
						'Blue sounded too cold at the time and yet it seemed to work for gin.',
					sender: 8,
					time: '09:11:26',
					status: null,
				},
				{
					content:
						'The small white buoys marked the location of hundreds of crab pots.',
					sender: null,
					time: '09:15:45',
					status: 'read',
				},
			],
		},
		group: false,
		pinned: false,
		typing: false,
	},
];

export const lastMessage: any = {
	content:
		'The green tea and avocado smoothie turned out exactly as would be expected.',
	sender: 2,
	time: '09:11:26',
	status: null,
};

export const user: any = {
	id: 1,
	profile_picture: '/static/media/profile-picture-girl-3.6f306e62.jpeg',
	name: 'Pulseem',
	phone_number: '+2348123456789',
	whatsapp_name: 'Beyonce',
	unread: 0,
	messages: {
		'04/06/2021': [
			{
				content:
					'She insisted that cleaning out your closet was the key to good driving.',
				sender: 1,
				time: '08:11:26',
				status: null,
			},
			{
				content:
					'Mary realized if her calculator had a history, it would be more embarrassing than her computer browser history.',
				sender: null,
				time: '08:15:45',
				status: 'read',
			},
			{
				content:
					"Gary didn't understand why Doug went upstairs to get one dollar bills when he invited him to go cow tipping.",
				sender: 1,
				time: '09:11:26',
				status: null,
			},
			{
				content: 'The bees decided to have a mutiny against their queen.',
				sender: null,
				time: '09:15:45',
				status: 'read',
			},
		],
		YESTERDAY: [
			{
				content:
					"Henry couldn't decide if he was an auto mechanic or a priest.",
				sender: 1,
				time: '08:11:26',
				status: null,
			},
			{
				content: 'I hear that Nancy is very pretty. ',
				sender: null,
				time: '08:15:45',
				status: 'read',
			},
			{
				content: 'Cats are good pets, for they are clean and are not noisy.',
				sender: 1,
				time: '09:11:26',
				status: null,
			},
			{
				content: 'They improved dramatically once the lead singer left. ',
				sender: null,
				time: '09:15:45',
				status: 'read',
			},
		],
		TODAY: [
			{
				content:
					'The small white buoys marked the location of hundreds of crab pots.',
				sender: null,
				time: '08:10:26',
				status: null,
			},
			{
				content:
					"Shakespeare was a famous 17th-century diesel mechanic. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
				sender: 1,
				time: '08:11:26',
				status: null,
			},
			{
				image: true,
				sender: 1,
				time: '09:12:26',
				status: null,
			},
			{
				content:
					'The small white buoys marked the location of hundreds of crab pots.',
				sender: null,
				time: '08:12:45',
				status: 'read',
			},
			{
				image: true,
				sender: null,
				time: '09:13:26',
				status: null,
			},
			{
				content: "Please put on these earmuffs because I can't you hear.",
				sender: 1,
				time: '09:20:26',
				status: null,
			},
			{
				content:
					"Henry couldn't decide if he was an auto mechanic or a priest.",
				sender: 1,
				time: '09:21:26',
				status: null,
			},
		],
	},
	group: false,
	pinned: true,
	typing: false,
};

export const messages: any = [
	{
		content:
			'The small white buoys marked the location of hundreds of crab pots.',
		sender: null,
		time: '08:10:26',
		status: null,
	},
	{
		content:
			"Shakespeare was a famous 17th-century diesel mechanic. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
		sender: 1,
		time: '08:11:26',
		status: null,
	},
	{
		image: true,
		sender: 1,
		time: '09:12:26',
		status: null,
	},
	{
		content:
			'The small white buoys marked the location of hundreds of crab pots.',
		sender: null,
		time: '08:12:45',
		status: 'read',
	},
	{
		image: true,
		sender: null,
		time: '09:13:26',
		status: null,
	},
	{
		content: "Please put on these earmuffs because I can't you hear.",
		sender: 1,
		time: '09:20:26',
		status: null,
	},
	{
		content: "Henry couldn't decide if he was an auto mechanic or a priest.",
		sender: 1,
		time: '09:21:26',
		status: null,
	},
];

export const allMessages: any = {
	'04/06/2021': [
		{
			content:
				'She insisted that cleaning out your closet was the key to good driving.',
			sender: 1,
			time: '08:11:26',
			status: null,
		},
		{
			content:
				'Mary realized if her calculator had a history, it would be more embarrassing than her computer browser history.',
			sender: null,
			time: '08:15:45',
			status: 'read',
		},
		{
			content:
				"Gary didn't understand why Doug went upstairs to get one dollar bills when he invited him to go cow tipping.",
			sender: 1,
			time: '09:11:26',
			status: null,
		},
		{
			content: 'The bees decided to have a mutiny against their queen.',
			sender: null,
			time: '09:15:45',
			status: 'read',
		},
	],
	YESTERDAY: [
		{
			content: "Henry couldn't decide if he was an auto mechanic or a priest.",
			sender: 1,
			time: '08:11:26',
			status: null,
		},
		{
			content: 'I hear that Nancy is very pretty. ',
			sender: null,
			time: '08:15:45',
			status: 'read',
		},
		{
			content: 'Cats are good pets, for they are clean and are not noisy.',
			sender: 1,
			time: '09:11:26',
			status: null,
		},
		{
			content: 'They improved dramatically once the lead singer left. ',
			sender: null,
			time: '09:15:45',
			status: 'read',
		},
	],
	TODAY: [
		{
			content:
				'The small white buoys marked the location of hundreds of crab pots.',
			sender: null,
			time: '08:10:26',
			status: null,
		},
		{
			content:
				"Shakespeare was a famous 17th-century diesel mechanic. It's not possible to convince a monkey to give you a banana by promising it infinite bananas when they die.",
			sender: 1,
			time: '08:11:26',
			status: null,
		},
		{
			image: true,
			sender: 1,
			time: '09:12:26',
			status: null,
		},
		{
			content:
				'The small white buoys marked the location of hundreds of crab pots.',
			sender: null,
			time: '08:12:45',
			status: 'read',
		},
		{
			image: true,
			sender: null,
			time: '09:13:26',
			status: null,
		},
		{
			content: "Please put on these earmuffs because I can't you hear.",
			sender: 1,
			time: '09:20:26',
			status: null,
		},
		{
			content: "Henry couldn't decide if he was an auto mechanic or a priest.",
			sender: 1,
			time: '09:21:26',
			status: null,
		},
	],
};

export const dates: any = ['04/06/2021', 'YESTERDAY', 'TODAY'];

export const attachButtons: any = [
	{
		icon: 'attachRooms',
		label: 'Choose room',
	},
	{
		icon: 'attachContacts',
		label: 'Choose contact',
	},
	{
		icon: 'attachDocument',
		label: 'Choose document',
	},
	{
		icon: 'attachCamera',
		label: 'Use camera',
	},
	{
		icon: 'attachImage',
		label: 'Choose image',
	},
];
